import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  @Input() titulo: string = ''
  @Input() capa: string = ''
  @Input() valor: string = ''
  @Input() medida: string = ''
  @Input() description: string = ''

  valorRounded;
  constructor() { }

  ngOnInit() {
    this.valorRounded =  parseFloat(this.valor).toFixed(2)
  }

}
